export default __webpack_public_path__ + "static/best-buy-0bc3aeca05f73284f9696c0787e0915d.png";